function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M20.9 19.8H1.1a1.1 1.1 0 100 2.2h19.8a1.1 1.1 0 100-2.2zM3.3 17.601h4.664a1.1 1.1 0 00.781-.319l7.612-7.62 3.124-3.058a1.1 1.1 0 000-1.561L14.817.325a1.1 1.1 0 00-1.562 0l-3.102 3.112-7.634 7.621a1.1 1.1 0 00-.319.78v4.664a1.1 1.1 0 001.1 1.1zM14.036 2.657l3.113 3.112-1.562 1.561-3.113-3.112 1.562-1.561zM4.4 12.29l6.523-6.521 3.113 3.112-6.523 6.52H4.4V12.29z"
}))));